//
//
//
//

export default {
  name: "CooperativeSetQuery",
};
